import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SlideShowService {


  public AuctionStatusBiddingOpen = 0
  public AuctionStatusBiddingPaused = 1
  public AuctionStatusFinalized = 2
  public OnlineBiddingNotEnabled = 3
  public OnlineBiddingTypeLive = 4

  public AUCTION_CONTROL_MANUAL = 0

  constructor(
    private http: HttpClient
  ) { }


  addCommasToNumber(number) {
    return window['utils'].getAmountDisplay(number);
  }

  getBidActivities(params) {
    const queryParams = [
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/auction/bidActivity', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getPayee(params) {
    const queryParams = [
      `handle=${encodeURIComponent(params.handle)}`,
      `ppid=${params.ppid}`
    ];
  return this.http.post('/api/payee', _.join(queryParams, "&"), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
  }

  getAuctionStatus(auctionData){
      var statusData = {
          "status"    : this.AuctionStatusBiddingOpen,
          "startsIn"  : 0,
          "type"      : auctionData.auctionType
      }

      if(auctionData.auctionStatus == this.AuctionStatusFinalized) {
          statusData.status = this.AuctionStatusFinalized
      } else if(auctionData.auctionControlMethod == this.AUCTION_CONTROL_MANUAL) {
          statusData.status = auctionData.auctionStatus
      } else {
          var auctionStartTime = auctionData.auctionStartTime
          var auctionEndTime = auctionData.auctionEndTime
          var timeNow = Math.floor(new Date().getTime() / 1000)
          if(auctionStartTime > timeNow) {
              statusData.status = this.AuctionStatusBiddingPaused
              statusData.startsIn = auctionStartTime - timeNow
          } else if(auctionEndTime < timeNow && auctionEndTime != 0) {
              statusData.status = this.AuctionStatusBiddingPaused
          } else {
              statusData.status = this.AuctionStatusBiddingOpen
          }
      }
      return statusData
  }
  
}
